var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useEffect, useState } from 'react';
import { Input } from '../../index.react';
import { createButtonStyle, createListStyle, createStyle } from './createStyle';
import useDropdown from '../useDropdown/useDropdown';

var Search = function Search(props) {
  var _a = props.suggestions,
      suggestions = _a === void 0 ? [] : _a,
      _b = props.onChangeValue,
      onChangeValue = _b === void 0 ? function (value) {
    if (value === void 0) {
      value = '';
    }
  } : _b,
      forwardedRef = props.forwardedRef,
      disabled = props.disabled,
      inputProps = __rest(props, ["suggestions", "onChangeValue", "forwardedRef", "disabled"]);

  var value = inputProps.value;

  var _c = useState(-1),
      selectedSuggestionIndex = _c[0],
      setSelectedSuggestionIndex = _c[1];

  var _d = useDropdown(),
      containerRef = _d[0],
      dropdownOpened = _d[1],
      open = _d[2],
      close = _d[3];

  var filteredSuggestions = suggestions.filter(function (_, index) {
    return index < 5;
  });
  useEffect(function () {
    if (value) onChangeValue(value.toString());
  }, [value]);
  useEffect(function () {
    var keyDownHandler = function keyDownHandler(e) {
      var keys = {
        Escape: function Escape() {
          open();
        },
        ArrowUp: function ArrowUp() {
          var nextSuggestion = function () {
            if (selectedSuggestionIndex - 1 < 0) return filteredSuggestions.length - 1;
            return selectedSuggestionIndex - 1;
          }();

          setSelectedSuggestionIndex(nextSuggestion);
        },
        ArrowDown: function ArrowDown() {
          var nextSuggestion = function () {
            if (selectedSuggestionIndex + 1 > filteredSuggestions.length - 1) return 0;
            return selectedSuggestionIndex + 1;
          }();

          setSelectedSuggestionIndex(nextSuggestion);
        },
        Enter: function Enter() {
          if (filteredSuggestions[selectedSuggestionIndex]) {
            onChangeValue(filteredSuggestions[selectedSuggestionIndex]);
            close();
          }
        },
        Tab: function Tab() {
          close();
        }
      };
      if (keys[e.key] && dropdownOpened) keys[e.key]();
    };

    document.addEventListener('keydown', keyDownHandler);
    return function () {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [dropdownOpened, selectedSuggestionIndex]);

  var handleChange = function handleChange(event) {
    setSelectedSuggestionIndex(-1);
    onChangeValue(event.target.value);
  };

  var handleFocus = function handleFocus(event) {
    if (inputProps.onFocus) inputProps.onFocus(event);
    open();
  };

  var handleInputClick = function handleInputClick() {
    open();
  };

  var hasLabel = Boolean(inputProps.label);
  return React.createElement("div", {
    className: createStyle(),
    ref: containerRef
  }, React.createElement(Input, __assign({}, inputProps, {
    onChange: handleChange,
    onClick: handleInputClick,
    onFocus: handleFocus,
    disabled: props.disabled,
    ref: forwardedRef
  })), filteredSuggestions.length > 0 && React.createElement("ul", {
    className: createListStyle({
      hasLabel: hasLabel,
      dropdownOpened: dropdownOpened
    })
  }, filteredSuggestions.map(function (suggestion, index) {
    return React.createElement("li", {
      key: suggestion
    }, React.createElement("button", {
      type: "button",
      className: createButtonStyle({
        active: index === selectedSuggestionIndex
      }),
      onClick: function onClick() {
        onChangeValue(filteredSuggestions[index]);
        close();
      }
    }, suggestion));
  })));
};

export default React.forwardRef(function (props, forwardedRef) {
  return React.createElement(Search, __assign({}, props, {
    forwardedRef: forwardedRef
  }));
});